import React, { useEffect } from 'react';
import { useDossier } from './DossierContext';

/**
 * Composant effect-only : déclenche `save()` toutes les 20 secondes
 * tant qu'il y a des modifications non sauvegardées.
 *
 * Rend `null` — c'est volontaire. La séparation entre la couche
 * "rendu" (Layout / Pane) et la couche "effets de bord"
 * (auto-save, raccourcis clavier) rend chacun trivialement testable
 * et facile à brancher/débrancher.
 *
 * Intervalle calé sur le legacy DossierDetails (20 s) pour ne pas
 * surprendre les utilisateurs habitués au rythme actuel.
 */
const AUTO_SAVE_INTERVAL_MS = 20_000;

const DossierAutoSave: React.FC = () => {
  const { hasUnsavedChanges, isSaving, save } = useDossier();

  useEffect(() => {
    const interval = setInterval(() => {
      if (hasUnsavedChanges && !isSaving) {
        void save();
      }
    }, AUTO_SAVE_INTERVAL_MS);
    return () => clearInterval(interval);
  }, [hasUnsavedChanges, isSaving, save]);

  return null;
};

export default DossierAutoSave;
